import { useDispatch, useSelector } from 'react-redux';
import { submitSearchFacet } from '../Actions/FacetedSearch.action';
import clsx from 'clsx';
import { translate } from '../Services/translation';
import React from 'react';

export function ClearFiltersButton({ className }) {
  const dispatch = useDispatch();
  const { facetFilters } = useSelector((state) => state.facetedSearch);

  function onClick() {
    if (facetFilters == null) {
      return;
    }

    const clearedFilters = facetFilters.map((filter) => {
      return { ...filter, selectedOptions: [] };
    });

    dispatch(submitSearchFacet(clearedFilters));
  }

  const activeFilters = facetFilters?.some(
    (filter) => filter.selectedOptions?.length > 0
  );

  if (!activeFilters) return null;

  return (
    <button type="button" onClick={onClick} className={className}>
      {translate('filter.clear')}
    </button>
  );
}

export default ClearFiltersButton;
